export default __webpack_public_path__ + "static/media/menu2.6d3b1c9e.svg";